import { render, staticRenderFns } from "./Registra.vue?vue&type=template&id=e3090410&"
import script from "./Registra.vue?vue&type=script&lang=js&"
export * from "./Registra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports